module.exports = __webpack_public_path__ + "img/icon-activity.cae05344.svg";